/**
 * Redirect map: old English product handles → current Italian handles.
 * Google may have indexed old English URLs before the store was localized to Italian.
 * Add new entries here as you discover more indexed old handles.
 */
export const productRedirects: Record<string, string> = {
  // === Braccialetti (Bracelets) ===
  'alpine-quickdraw-bracelet': 'braccialetto-rinvio',
  'quickdraw-bracelet': 'braccialetto-rinvio',
  'mountaineering-quickdraw-bracelet': 'braccialetto-rinvio-alpinistico',
  'alpine-mountaineering-quickdraw-bracelet': 'braccialetto-rinvio-alpinistico',
  'nomic-bracelet': 'braccialetto-nomic',
  'ice-axe-bracelet': 'braccialetto-piccozza',
  'downhill-ski-bracelet': 'braccialetto-sci-da-discesa',
  'skiing-bracelet': 'braccialetto-sci-da-discesa',
  'snowboard-bracelet': 'braccialetto-snowboard',
  'tre-cime-di-lavaredo-bracelet': 'braccialetto-tre-cime-di-lavaredo',
  'three-peaks-bracelet': 'braccialetto-tre-cime-di-lavaredo',
  '8-horseshoes-bracelet': 'braccialetto-8-ferri-di-cavallo',
  'horseshoe-bracelet': 'braccialetto-8-ferri-di-cavallo',

  // === Collane (Necklaces) ===
  'grigri-plus-necklace': 'collana-grigri-plus',
  'figure-eight-descender-necklace': 'collana-discensore-otto',
  'descender-necklace': 'collana-discensore-otto',
  'quickdraw-necklace': 'collana-rinvio',
  'cams-necklace': 'collana-eccentrici',
  'cam-necklace': 'collana-eccentrici',
  'pitons-necklace': 'collana-chiodi',
  'piton-necklace': 'collana-chiodi',
  'ski-necklace': 'collana-sci',
  'snowboard-necklace': 'collana-snowboard',
  'friend-necklace': 'collana-friend',
  'friend-and-quickdraws-necklace': 'collana-friend-e-rinvii',
  'friend-and-quickdraw-necklace': 'collana-friend-e-rinvio',
  'quickdraws-necklace': 'collana-rinvii',
  'classic-ice-axe-necklace': 'collana-piccozza-classica',
  'edelweiss-necklace': 'collana-stella-alpina',
  'ice-axe-necklace': 'collana-piccozza',
  'climbing-shoes-necklace': 'collana-scarpette',
  'ice-screws-necklace': 'collana-viti-da-ghiaccio',
  'gigi-plate-necklace': 'collana-piastrina-gigi',
  'nomic-necklace': 'collana-nomic',
  'snowboarder-necklace': 'collana-snowboarder',
  'boulder-necklace': 'collana-boulder',
  'mythos-necklace': 'collana-mythos',
  'grigri-necklace': 'collana-grigri',
  'grigri-i-necklace': 'collana-grigri-i',
  'belay-ring-necklace': 'collana-bracciale-ghiera',
  'horse-necklace': 'collana-cavallo',
  'horseshoe-necklace': 'collana-ferro-di-cavallo-singolo',
  '8-horseshoes-necklace': 'collana-8-ferri-di-cavallo',
  'trio-horses-necklace': 'collana-trio-cavalli',
  'snaffle-bit-necklace': 'collana-morso-filetto',
  'pelham-bit-necklace': 'collana-morso-pellham',
  'western-bit-necklace': 'collana-morso-western',
  'western-hat-lasso-necklace': 'collana-cappello-western-e-lazo',
  'wolf-tomahawk-necklace': 'collana-lupo-con-tomahawk-e-piume',
  'roe-deer-antlers-necklace': 'collana-corna-di-capriolo-e-rami-abete',
  'roe-deer-antlers-berries-necklace': 'collana-corna-di-capriolo-e-rami-abete-e-bacche',

  // === Orecchini (Earrings) ===
  'friend-earrings': 'orecchini-friend',
  'cam-earrings': 'orecchini-eccentrici',
  'cams-earrings': 'orecchini-eccentrici',
  'piton-earrings': 'orecchini-chiodi',
  'pitons-earrings': 'orecchini-chiodi',
  'carabiner-earrings': 'orecchini-moschettone',
  'quickdraw-earrings': 'orecchini-rinvio',
  'edelweiss-earrings': 'orecchini-stella-alpina',
  'figure-eight-earrings': 'orecchini-otto',
  'ice-axe-earrings': 'orecchini-piccozza',
  'snowboarder-earrings': 'orecchini-snowboarder',

  // === Portachiavi (Keychains) ===
  'gigi-plate-keychain': 'portachiavi-piastrina-gigi',
  'trekking-boots-keychain': 'portachiavi-scarponi-trekking',
  'classic-mountaineering-set-keychain': 'portachiavi-set-alpinismo-classico',
  'sport-climbing-set-keychain': 'portachiavi-set-arrampicata-sportiva',
  'rope-and-ice-axe-keychain': 'portachiavi-corda-e-piccozza-classica',
  'rope-and-ice-axes-keychain': 'portachiavi-corda-e-piccozze',
  'pitons-keychain': 'portachiavi-chiodi',
  'friend-keychain': 'portachiavi-friend',
  'mythos-keychain': 'portachiavi-mythos',
  'nomic-keychain': 'portachiavi-nomic',
  'skier-keychain': 'portachiavi-sciatore',
  'grigri-keychain': 'portachiavi-grigri',
  'snowshoe-keychain': 'portachiavi-ciaspola',
  'ski-keychain': 'portachiavi-sci',
  'rope-keychain': 'portachiavi-corda',
  'climbing-rope-keychain': 'portachiavi-corda',
  'backpack-keychain': 'portachiavi-zaino',
  'rope-hammer-pitons-keychain': 'portachiavi-corda-martello-e-chiodi',
  'hammer-and-pitons-keychain': 'portachiavi-corda-martello-e-chiodi',

  // === Cinture (Belts) ===
  'deer-belt': 'cintura-cervo',
  'stag-belt': 'cintura-cervo',
  'wild-boar-belt': 'cintura-cinghiale',
  'roe-deer-belt': 'cintura-capriolo',
  'eagle-belt': 'cintura-aquila',
  'bison-belt': 'cintura-bisonte',
  'african-buffalo-belt': 'cintura-bufalo-africano',
  'chamois-belt': 'cintura-camoscio',
  'galloping-horses-belt': 'cintura-cavalli-al-galoppo',
  'horse-and-horseshoe-belt': 'cintura-cavallo-e-ferro-di-cavallo',
  'drahthaar-belt': 'cintura-drahtaar',
  'elephant-belt': 'cintura-elefante',
  'horseshoe-belt': 'cintura-ferro-di-cavallo',
  'capercaillie-belt': 'cintura-gallo-cedrone',
  'lion-belt': 'cintura-leone',
  'leopard-belt': 'cintura-leopardo',
  'bears-belt': 'cintura-orsi',
  'bear-belt': 'cintura-orsi',
  'ibex-belt': 'cintura-stambecchi',
  'zebra-belt': 'cintura-zebra',

  // === Tappi (Corks / Bottle Stoppers) ===
  'capercaillie-cork': 'tappo-gallo-cedrone',
  'capercaillie-stopper': 'tappo-gallo-cedrone',
  'black-grouse-cork': 'tappo-gallo-forcello',
  'black-grouse-stopper': 'tappo-gallo-forcello',
  'deer-cork': 'tappo-cervo',
  'deer-stopper': 'tappo-cervo',
  'stag-cork': 'tappo-cervo',
  'chamois-cork': 'tappo-camoscio',
  'chamois-stopper': 'tappo-camoscio',
  'ibex-cork': 'tappo-stambecco',
  'ibex-stopper': 'tappo-stambecco',
  'mouflon-cork': 'tappo-muflone',
  'mouflon-stopper': 'tappo-muflone',
  'wild-boar-cork': 'tappo-cinghiale',
  'wild-boar-stopper': 'tappo-cinghiale',
  'marmot-cork': 'tappo-marmotta',
  'marmot-stopper': 'tappo-marmotta',
  'squirrel-cork': 'tappo-scoiattolo',
  'squirrel-stopper': 'tappo-scoiattolo',
  'hunter-cork': 'tappo-cacciatore',
  'hunter-stopper': 'tappo-cacciatore',
  'roe-deer-cork': 'tappo-capriolo',
  'roe-deer-stopper': 'tappo-capriolo',

  // === Spille (Pins) ===
  'deer-skull-pin': 'spilla-teschio-cervo',
  'stag-skull-pin': 'spilla-teschio-cervo',
  'chamois-skull-pin': 'spilla-teschio-camoscio',
  'roe-deer-skull-pin': 'spilla-teschio-capriolo',
  'wild-boar-pin': 'spilla-cinghiale',
  'boar-head-pin': 'spilla-testa-cinghiale',
  'roe-deer-antlers-pin': 'spilla-corni-capriolo',
  'black-grouse-chamois-pin': 'spilla-gallo-forcello-e-camoscio',
  'mouflon-pin': 'spilla-muflone',
  'hunting-horn-pin': 'spilla-corno-da-caccia',
  'owl-pin': 'spilla-gufo',
  'black-grouse-pin': 'spilla-gallo-forcello',
  'capercaillie-head-pin': 'spilla-testa-gallo-cedrone',
  'fox-pin': 'spilla-volpe',
  'capercaillie-pin': 'spilla-gallo-cedrone',
  'feather-holder-pin': 'spilla-porta-piume',
};